/**
 * ThemeToggle — #2325
 *
 * Three-way cycle: dark → light → system → dark
 * Rendered in FleetLayout header right-side cluster.
 */

import { useTheme, type ThemeChoice } from "../context/ThemeContext";

const LABELS: Record<ThemeChoice, string> = {
  dark:   "☾",
  light:  "☀",
  system: "◑",
};

const TITLES: Record<ThemeChoice, string> = {
  dark:   "Dark mode (click for light)",
  light:  "Light mode (click for system)",
  system: "System theme (click for dark)",
};

const CYCLE: Record<ThemeChoice, ThemeChoice> = {
  dark:   "light",
  light:  "system",
  system: "dark",
};

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const next = CYCLE[theme];

  return (
    <button
      onClick={() => setTheme(next)}
      title={TITLES[theme]}
      aria-label={TITLES[theme]}
      data-testid="theme-toggle"
      style={{
        display: "flex", alignItems: "center", justifyContent: "center",
        width: 30, height: 30, flexShrink: 0,
        background: "transparent",
        border: "1px solid transparent",
        borderRadius: "var(--brand-radius-sm)",
        color: "var(--brand-text-muted)",
        cursor: "pointer",
        fontSize: "0.95rem",
        transition: "var(--brand-transition-fast)",
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLButtonElement).style.background = "var(--brand-bg-overlay)";
        (e.currentTarget as HTMLButtonElement).style.borderColor = "var(--brand-border-subtle)";
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLButtonElement).style.background = "transparent";
        (e.currentTarget as HTMLButtonElement).style.borderColor = "transparent";
      }}
    >
      {LABELS[theme]}
    </button>
  );
}
